//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/Builder.js";
let d=[[],[[["num_contents"],"GetContents",{R_:{contents:"MBD.WebLibraryContent[]"}},0,0],[["ruleToSelect"],"SelectRule",{},1,0],[[],"GetSelectedRule",{R_:{selectedRule:"MBD.WebLibraryRule"}},0,0]],[]];
SPLM.MBD.WebRuleLibraryBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.WebRuleLibraryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;